import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gpv-asset-usecases',
  templateUrl: './asset-usecases.component.html',
  styleUrls: ['./asset-usecases.component.css']
})
export class AssetUsecasesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
